import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class ContratService {
    
    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/contrat/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/contrat/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/contrat/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/contrat/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/contrat/delete/${id}`), callback);
    
}